import { IRateLimit } from '@shared/interface/rate-limit.interface';

export class ApiError extends Error {
  private readonly ERROR_LABEL = 'Error: ';
  public readonly code?: string;
  public readonly rateLimit?: IRateLimit;

  constructor(message: string, code?: string, rateLimit?: IRateLimit) {
    super(message);

    this.name = super.name;
    this.message =
      super.message != null && super.message !== ''
        ? super.message.toString()
        : message;

    // Set code
    if (code != null) {
      this.code = code;
    } else {
      this.code = this.message.includes(this.ERROR_LABEL)
        ? this.message.replace(this.ERROR_LABEL, '')
        : undefined;
    }

    // Clean message
    this.message = this.message.startsWith(this.ERROR_LABEL)
      ? this.message.replace(this.ERROR_LABEL, '')
      : this.message;

    // Set RateLimit
    if (rateLimit != null) {
      this.rateLimit = rateLimit;
    }
  }
}
